import React from 'react';

const avantages = [
   {
      name: 'Flexibilité totale',
      description: 'Un programme pensé pour s’adapter au calendrier scolaire, au rythme et au niveau de chaque apprenant.',
      features: [
         "Flexible : Programme hybride adapté au calendrier scolaire",
         "Auto-apprentissage guidé + kits projets",
         "Tutorat 1:1",
         "Apprentissage pratique : Stages + résidence créative",
         "Certification pour booster son dossier académique."
      ],
   },
   {
      name: 'Un accompagnement humain',
      description: 'Une pédagogie hybride (en ligne + présentiel) avec des tuteurs passionnés qui guident chaque étape.',
      features: [
         "Parcours intensif hybride (présentiel + en ligne).",
         "Tronc commun + spécialisation (design, fabrication numérique, électronique, IoT…).",
         "Apprentissage par projets.",
         "Tutorat international & peer-to-peer learning.",
         "Projet final → Certification & ouverture sur des opportunités."
      ],
      button: 'Explorer les Bootcamps'
   },
   {
      name: 'Une certification valorisante',
      target: "Un atout concret pour les dossiers académiques, les concours et les futures opportunités.",
      age: "18+",
      description: 'S’élever & certifier ses compétences',
      features: [
         "Coaching personnalisé avec des tuteurs internationaux.",
         "Préparation aux certifications makers reconnues (FabAcademy, MITx, etc.).",
         "Parcours flexible et adapté aux objectifs pros ou académiques."
      ],
      button: 'Trouver mon tuteur'
   }
];

const Avantages = () => {
   return (
      <section className="py-12 md:py-16 lg:py-24 bg-light-5 dark:bg-dark-2">
         <div className="container mx-auto px-4 max-w-6xl">
            <div className="text-center mb-10">
               <h2 className="text-3xl md:text-4xl font-bold text-dark-1 dark:text-white mb-2">Les Avantages</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
               {avantages.map((plan, index) => (
                  <div key={index} className="rounded-xl bg-light-5 text-dark-1 w-full h-auto">
                     <div className="h-auto text-dark-1 text-start p-6  rounded-t-xl">
                        <div className="flex items-baseline">
                           {plan.name && <span className="text-3xl font-semibold flex items-start">
                              {plan.name}
                           </span>}
                        </div>
                     </div>

                     <div className='p-6 h-auto flex flex-col justify-between'>
                        <span className="text-base font-medium mb-4 block text-gray-600 dark:text-gray-300">
                           {plan.description}
                        </span>
                        {/* <ul className="space-y-3 mb-6">
                           {plan.features.map((feature, i) => (
                              <li key={i}
                                 className="text-sm flex items-start text-gray-700 dark:text-gray-300"
                              >
                                 <svg
                                    className="h-4 w-4 mt-0.5 mr-2 flex-shrink-0 text-purple-1 dark:text-purple-300"
                                    fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                 </svg>
                                 {feature}
                              </li>
                           ))}
                        </ul> */}
                     </div>
                  </div>
               ))}
            </div>
         </div>
      </section>
   );
};

export default Avantages;